import { useEffect, useMemo, useState } from 'react';
import { Client, SyftProperties } from '@types';
import { LoadingCard } from '@/components/DashboardCard';
import SyftDashboard from '@/components/SyftDashboard/SyftDashboard';
import useInvestor from '@/hooks/useInvestor';
import useStorageData from '@/hooks/useStorageData';
// import { OnChangeValue } from 'react-select';
import { IUserContext, useUserContext } from '@/context/UserContext';
import { safeParseJson } from '@/components/AccountDetails/utils';
import { getSyftURLToShow } from '@/utils/clientConfigUtils';

interface SelectedStartups {
  label: string;
  value: number;
}

function MultiStartupSyftDashboard() {
  const { auth }: IUserContext = useUserContext(); // Use the conte
  const { useStartups } = useInvestor();
  // const { getSyftDashboardStorageData, saveSyftDashboardStorageData } =
  const { saveSyftDashboardStorageData } = useStorageData();
  const { data, isLoading, error } = useStartups();
  const [selectedStartups, setSelectedStartups] = useState<
    readonly SelectedStartups[]
  >([]);
  const startupOptions = useMemo(
    () =>
      data
        ?.filter(
          (startup) =>
            auth?.isSuperAdmin || auth?.authorizedClientIds.includes(startup.id)
        )
        .map((client: Client) => ({
          label: client.client_name,
          value: client.id,
        })),
    [data, auth]
  );

  // #region SC-3092 - Remove Dashboard Selection
  // useEffect(() => {
  //   if (data && !isLoading) {
  //     const localStorageData = getSyftDashboardStorageData(
  //       auth?.email_address as string
  //     );
  //     let startupSelections: SelectedStartups[] = [];
  //     if (localStorageData) {
  //       // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  //       const localStorageDataObject: {
  //         label: string;
  //         value: number;
  //       }[] = JSON.parse(localStorageData);
  //       let dataModified = false;
  //       localStorageDataObject.forEach((storageData, index) => {
  //         if (!data.find((client) => client.id === storageData.value)) {
  //           localStorageDataObject.splice(index, 1);
  //           dataModified = true;
  //         }
  //       });

  //       if (dataModified)
  //         saveSyftDashboardStorageData(
  //           auth?.email_address as string,
  //           localStorageDataObject
  //         );

  //       startupSelections =
  //         localStorageDataObject.length > 0
  //           ? localStorageDataObject
  //           : startupOptions || [];
  //     } else {
  //       startupSelections = startupOptions || [];
  //     }

  //     setSelectedStartups(startupSelections);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [data]);
  // #endregion SC-3092 - Remove Dashboard Selection

  // #region SC-3092 - Remove Dashboard Selection
  useEffect(() => {
    if (data && !isLoading) {
      const startupSelections = startupOptions || [];
      saveSyftDashboardStorageData(
        auth?.email_address as string,
        startupSelections
      );

      setSelectedStartups(startupSelections);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
  // #endregion SC-3092 - Remove Dashboard Selection

  if (isLoading) return <LoadingCard />;
  if (error) return <div>Failed to load</div>;
  if (!data) return <div>No data</div>;

  const userFirmsIds = auth?.firms?.map((firm) => firm.id) || [];

  // #region SC-3092 - Remove Dashboard Selection
  // const onChange = (
  //   e: OnChangeValue<{ label: string; value: number }, true>
  // ) => {
  //   saveSyftDashboardStorageData(auth?.email_address as string, e);
  //   setSelectedStartups(e);
  // };
  // #endregion SC-3092 - Remove Dashboard Selection

  return (
    <div>
      {/* #region SC-3092 - Remove Dashboard Selection */}
      {/* <Select
        isMulti
        className='react-select-container border-accent w-1/3 mt-4 ml-4'
        classNamePrefix='react-select'
        placeholder='select dashboards...'
        noOptionsMessage={() => 'No Dashboards'}
        closeMenuOnSelect={false}
        options={startupOptions}
        value={selectedStartups}
        onChange={onChange}
      /> */}
      {/* #endregion SC-3092 - Remove Dashboard Selection */}
      {data
        ?.filter((client) =>
          selectedStartups?.some((s) => s.value === client.id)
        )
        .map((client) => {
          const clientName = client.client_name;
          const syftUrlArray = client.config
            ?.filter(({ config_key }) => config_key === 'syft_url')
            .map(({ config_value }) => config_value);
          const syftUrlOptions = syftUrlArray?.length ? syftUrlArray[0] : '';
          const parseSyftUrlOptions = safeParseJson(
            syftUrlOptions,
            []
          ) as SyftProperties[];

          const syftUrlToShow = getSyftURLToShow(
            parseSyftUrlOptions,
            userFirmsIds,
            auth?.id as number
          );

          return syftUrlToShow ? (
            <SyftDashboard
              syftUrl={syftUrlToShow}
              title={clientName}
              key={clientName}
            />
          ) : null;
        })}
    </div>
  );
}

export default MultiStartupSyftDashboard;
